import { useLingui } from '@lingui/react/macro';
import { Typography } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { DecimalInputField } from '@/components/input_field/decimal_input_field';
import type { OrderType } from '@/feature/order_entry/order_types';
import { useOrderFormContext } from '../order_context';
import type { OrderFormData } from '../order_schema';

type StopOrderFieldNames = keyof Extract<
  OrderFormData,
  { orderType: typeof OrderType.stopMarket | typeof OrderType.stopLimit }
>;

interface StopPriceFieldProps {
  fieldName: StopOrderFieldNames;
}

export function StopPriceField({ fieldName }: StopPriceFieldProps) {
  const { t } = useLingui();
  const formContext = useFormContext<OrderFormData>();
  const { disabled, marketData } = useOrderFormContext();

  const fieldLabel = t({
    comment:
      'Trade console trigger price input label. This is a field label, so use a noun phrase ("trigger price") to match the surrounding labels — not a verb phrase like "it will fire when…".',
    message: 'Trigger at',
  });

  const stopPriceToken = {
    symbol: marketData?.quote.symbol || 'USD',
    decimals: marketData?.quoteDecimals ?? 2,
    display_precision: marketData?.quoteDecimals ?? 2,
  };

  return (
    <Controller
      control={formContext.control}
      name={fieldName as any}
      render={({ field }) => (
        <DecimalInputField
          maxPrecision={stopPriceToken.display_precision}
          value={field.value}
          label={fieldLabel}
          onChange={(value) => {
            field.onChange(value);
          }}
          disabled={disabled}
          endAdornment={
            <Typography variant="button" fontWeight={400} color="textPrimary">
              USD
            </Typography>
          }
        />
      )}
    />
  );
}
